import React, { useEffect, useState } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonButton,
  IonIcon,
  IonFab,
  IonFabButton,
  IonSearchbar,
  IonChip,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonListHeader,
  IonSelect,
  IonSelectOption,
  IonAlert,
} from "@ionic/react";
import {
  add,
  receipt,
  time,
  checkmarkCircle,
  closeCircle,
  fastFood,
  cart,
  person,
  cash,
  refresh,
  statsChart,
  card,
} from "ionicons/icons";
import {
  Box,
  Typography,
  Avatar,
  Badge,
  LinearProgress,
  Divider,
  Chip as MuiChip,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  getAllMyOrders,
  getMyOrders,
  processPayment,
  sendOTP,
} from "../../../api/orders/orders";
import { formatToNaira } from "../../../common/utils_t";
import { Capacitor } from "@capacitor/core";
// import { BarcodeScanner } from "@capacitor-mlkit/barcode-scanning";
import { Link } from "react-router-dom";
import { generateToken, verifyToken } from "../../../common/utils";

// Styled Components
const StatusBadge = styled(IonBadge)(({ status }: { status: string }) => ({
  "--background":
    status === "preparing"
      ? "#FFA726"
      : status === "ready"
      ? "#66BB6A"
      : "#BDBDBD",
  textTransform: "capitalize",
}));

const QuickActionButton = styled(IonButton)({
  height: "80px",
  "--border-radius": "12px",
});

const OrderCard = styled(IonCard)({
  borderRadius: "12px",
  margin: "8px 0",
});

const StewardDashboard: React.FC = () => {
  const [searchText, setSearchText] = useState("");
  const [segment, setSegment] = useState("COMPLETED");
  const [showOrderDetails, setShowOrderDetails] = useState(null);
  const [errors, setErrors] = useState("");
  const [paymentOption, setPaymentOption] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  // const [showOrderDetails, setshowOrderDetails] = useState<Order | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const { business_id, branch_id } = useParams<RouteParamsProps>();
  const [status, setStatus] = useState({ isLoading: false, error: false });

  const [orders, setOrders] = useState([]);

  const [scanResult, setScanResult] = useState<string | null>(null);
  const [qrValue, setQrValue] = useState<string>("");

  const startScan = async () => {
    try {
      // Request camera permission
      if (Capacitor.isNativePlatform()) {
        const permission = await BarcodeScanner.requestPermissions();

        if (!permission) {
          console.log("Camera permission not granted");
          return;
        }
      }

      // Start scanning
      const result = await BarcodeScanner.scan();
      if (result && result.barcodes.length > 0) {
        setScanResult(result.barcodes[0].displayValue || null);
        alert("scan successful " + result.barcodes[0].displayValue);
      } else {
        setScanResult("No barcode found");
      }
    } catch (error) {
      console.error("Error scanning:", error);
    }
  };

  const filteredOrders = orders?.filter((order) => {
    if (segment === "all") return true;

    if (segment == "WAITING") {
      return order.order_status == "WAITING";
    }

    if (segment == "COMPLETED") {
      return order.order_status == "COMPLETED" && order.payment_status == "0";
    }

    if (segment == "1") {
      return order.payment_status == "1";
    }

    return false;
  });

  //console.log({ filteredOrders });

  const completedCount = orders?.filter(
    (order) => order.order_status === "COMPLETED" && order.payment_status == "0"
  ).length;
  const waitingCount = orders?.filter(
    (order) => order.order_status === "WAITING"
  ).length;
  const cancelledCount = orders?.filter(
    (order) => order.order_status === "CANCELLED"
  ).length;
  const paidCount = orders?.filter(
    (order) => order.payment_status === "1"
  ).length;

  const getOrders = async () => {
    setStatus({ isLoading: true, error: false });
    try {
      const result = await getAllMyOrders();
      setOrders(result.data);
    } catch (error: any) {
      if (error.response || error.response.status === 422) {
        // Set errors from Laravel validation response
        setErrors(error.response.data.message);
      } else {
        console.error("An unexpected error occurred:", error);
      }

      setStatus({ isLoading: false, error: true });
    } finally {
      setStatus({ isLoading: false, error: false });
    }
  };

  useEffect(() => {
    // Call once immediately
    getOrders();

    // Set interval to call every 10 seconds
    const interval = setInterval(() => {
      getOrders();
    }, 10000); // 10000ms = 10s

    // Clear the interval on component unmount
    return () => clearInterval(interval);
  }, []);


   useEffect(() => {
  if (paymentOption === 'wallet_qrcode') {
    setLockPay(true);
  } else {
    setLockPay(false);
  }
}, [paymentOption]);


  const handleOTP = async () => {
    const payload = {
      order_id: showOrderDetails?.order_id,
      paymentMethod: paymentOption,
      memberId: showOrderDetails.member_id,
    };

    // console.log({payload})

    setStatus({ isLoading: true, error: false });
    try {
      const response = await sendOTP(payload);
      console.log("otp", response);

      setStatus({ isLoading: false, error: false });
    } catch (error: any) {
      setStatus({ isLoading: false, error: true });
      if (error.response) {
        setErrors(error.response.data.error || error.response.data.message);
      } else {
        console.error("An unexpected error occurred:", error);
      }
    }
  };

  const handleProcessPayment = async () => {
    // console.log("Processing payment for order:", selectedMember);


 
    try {
      const payload = {
        order_id: showOrderDetails?.order_id,
        paymentMethod: paymentOption,
        memberId: showOrderDetails.member_id,
        otp: otp,
      };

      // console.log({payload})
      // return
      const response = await processPayment(payload);
      console.log("Payment response:", response);
      alert(response.message);
      setToastMessage("Payment processed successfully!");
      setOtp('');
          setResult('');

      setLockPay(true);
      setToastMessage(response.message);
      setShowToast(true);
      setIsModalOpen(false);
      // setOpenAddModal(false);
      getOrders();
      // setOpenAddModal(false);
      setShowOrderDetails(null);
      // getOrders();

      // Show success message
    } catch (error) {
      console.error("Payment processing error:", error);
      setToastMessage("Payment failed. Please try again.");
      setShowToast(true);
    }
  };
 
   //const [memberId, setMemberId] = useState('1024');
   const [lockPay, setLockPay] = useState(false);

  const [token, setToken] = useState('');
  const [result, setResult] = useState('');
  const expirationType = '1min';
 

  const handleVerify = async (newToken) => {
    const res = await verifyToken(newToken, showOrderDetails.member_id, expirationType);


     res.valid ? setLockPay(false) : setLockPay(true);

    setResult(res.valid ? `✅ Correct App-OTP` : '❌ Invalid or expired OTP');
    console.log(res.valid ? `✅ Correct App-OTP ${showOrderDetails.member_id}` : `❌ Invalid or expired OTP ${showOrderDetails.member_id}`);
  };

  return (
    <IonPage className="pushDown">
      <IonHeader className="app-header">
        <IonToolbar className="app-toolbar">
          <Avatar sx={{ width: 32, height: 32 }}>ST</Avatar>
          <IonTitle>Steward Dashboard</IonTitle>
          <Box
            slot="end"
            sx={{ display: "flex", alignItems: "center", gap: "12px", mr: 2 }}
          >
            <Badge badgeContent={3} color="error" >
              <Link to="/steward/notification">
              <IonIcon icon={receipt}  style={{ fontSize: "24px" }} />
              </Link>
            </Badge>
          </Box>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {/* Quick Stats */}

        <IonAlert
          isOpen={showToast}
          onDidDismiss={() => setShowAlert(false)}
          header="Notice"
          message={toastMessage}
          buttons={["Close"]}
        />
        <Box
          sx={{
            px: 2,
            py: 1,
            display: "grid",
            gridTemplateColumns: "auto auto auto auto",
            gap: 2,
          }}
        >
          <IonCard>
            <IonCardContent style={{ textAlign: "center" }}>
              <Typography variant="h6">WAITING</Typography>
              <Typography variant="h4" color="primary">
                {waitingCount}
              </Typography>
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonCardContent style={{ textAlign: "center" }}>
              <Typography variant="h6">COMPLETED</Typography>
              <Typography variant="h4" color="success">
                {completedCount}
              </Typography>
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonCardContent style={{ textAlign: "center" }}>
              <Typography variant="h6">PAID</Typography>
              <Typography variant="h4" color="success">
                {paidCount}
              </Typography>
            </IonCardContent>
          </IonCard>
          <IonCard>
            <IonCardContent style={{ textAlign: "center" }}>
              <Typography variant="h6">CANCELLED</Typography>
              <Typography variant="h4" color="error">
                {cancelledCount}
              </Typography>
            </IonCardContent>
          </IonCard>
        </Box>

        {/* Search and Filter */}
        <IonSearchbar
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
          placeholder="Search orders..."
        />

        <IonSegment
          value={segment}
          onIonChange={(e) => setSegment(e.detail.value!)}
          scrollable
        >
          {/*   <IonSegmentButton value="all">
            <IonLabel>All</IonLabel>
          </IonSegmentButton> */}
          <IonSegmentButton value="WAITING">
            <IonLabel>Waiting</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="COMPLETED">
            <IonLabel>Completed</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="1">
            <IonLabel>Paid</IonLabel>
          </IonSegmentButton>
        </IonSegment>

        {/* Quick Actions */}
        <Box
          sx={{
            px: 2,
            py: 1,
            display: "grid",
            gridTemplateColumns: "auto auto ",
            gap: 2,
            overflowX: "auto",
          }}
        >
          {/* <QuickActionButton
            expand="block"
            color="primary"
            routerLink="/steward/orders"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IonIcon icon={add} size="large" />
              <Typography variant="caption">New Order</Typography>
            </Box>
          </QuickActionButton> */}

          <QuickActionButton
            expand="block"
            color="secondary"
            routerLink="/folder/reports/:reports"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IonIcon icon={statsChart} size="large" />
              <Typography variant="caption">Reports</Typography>
            </Box>
          </QuickActionButton>

          <QuickActionButton expand="block" color="tertiary">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IonIcon icon={refresh} size="large" />
              <Typography variant="caption">Refresh</Typography>
            </Box>
          </QuickActionButton> 
        </Box>

        {/* Orders List */}
        <IonList>
          {filteredOrders?.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <IonIcon
                icon={receipt}
                style={{ fontSize: "48px", color: "#999" }}
              />
              <Typography variant="body1" color="text.secondary">
                No orders found
              </Typography>
            </Box>
          ) : (
            filteredOrders?.map((order) => (
              <OrderCard
                key={order.order_id}
                onClick={() => setShowOrderDetails(order)}
              >
                <IonCardHeader>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography fontWeight="bold">
                      Customer Name: {order.member_name}
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography fontWeight="">
                      Order Code: {order.order_code} | {order.order_date}
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <IonIcon icon={time} size="small" />
                      <Typography variant="body2">
                        {new Date(order.order_date).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </Typography>
                    </Box>
                  </Box>
                </IonCardHeader>
                <IonCardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <IonIcon icon={cart} size="small" />
                      <Typography>{order.items.length} items</Typography>
                    </Box>
                    <StatusBadge status={order.order_status}>
                      {order.order_status}
                    </StatusBadge>
                  </Box>

                  <List dense>
                    {order.items.slice(0, 2).map((item, index) => (
                      <ListItem key={index} sx={{ px: 0 }}>
                        <ListItemText
                          primary={item.productName}
                          secondary={`${item.quantity}x ${formatToNaira(
                            item.price
                          )}`}
                        />
                        <Typography>
                          {formatToNaira(item.total_amount)}
                        </Typography>
                      </ListItem>
                    ))}
                    {order.items.length > 2 && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                      >
                        +{order.items.length - 2} more items
                      </Typography>
                    )}
                  </List>

                  <Divider sx={{ my: 1 }} />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      Total:
                    </Typography>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatToNaira(order.payable_amount)}
                    </Typography>
                  </Box>
                </IonCardContent>
              </OrderCard>
            ))
          )}
        </IonList>

        {/* Order Details Modal */}
        {showOrderDetails && (
          <IonCard
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "500px",
              zIndex: 1000,
              borderRadius: "16px",
            }}
          >
            <IonCardHeader>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <IonCardTitle>Order Details</IonCardTitle>
                <IonButton
                  fill="clear"
                  onClick={() => setShowOrderDetails(null)}
                >
                  Close
                </IonButton>
              </Box>
            </IonCardHeader>

            <IonCardContent
              style={{
                maxHeight: "60vh",
                overflowY: "auto",
                paddingRight: "8px",
              }}
            >
              <Box sx={{ mb: 2 }}>
                <Typography variant="body1" fontWeight="bold">
                  {showOrderDetails.order_code}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {new Date(showOrderDetails.order_date).toLocaleString()}
                </Typography>
                <StatusBadge status={showOrderDetails.order_status}>
                  {showOrderDetails.order_status}
                </StatusBadge>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  Member Name: {showOrderDetails.member_name}
                </Typography>
              </Box>

              <List>
                {showOrderDetails?.items.map((item, index) => (
                  <ListItem key={index}>
                    <ListItemAvatar>
                      <Avatar>{item?.product_name?.charAt(0)}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={item?.product_name}
                      secondary={`${item.quantity} × ${formatToNaira(
                        item.price
                      )}`}
                    />
                    <Typography>{formatToNaira(item.total_amount)}</Typography>
                  </ListItem>
                ))}
              </List>

              <Divider sx={{ my: 2 }} />

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  Total Amount:
                </Typography>
                <Typography variant="subtitle1" fontWeight="bold">
                  {formatToNaira(showOrderDetails.payable_amount)}
                </Typography>
              </Box>
              {segment !== "1" &&
                showOrderDetails?.order_status == "COMPLETED" && (
                  <IonList lines="none" className="payment-section">
                    {/*hide lola start  */}

                    {showOrderDetails?.order_status == "COMPLETED" && (
                      <IonList lines="none" className="payment-section">
                        <IonListHeader>
                          <IonLabel>Payment Options</IonLabel>
                        </IonListHeader>

                        <IonItem>
                          <IonSelect
                            label="Select payment method"
                            labelPlacement="floating"
                            value={paymentOption}
                            onIonChange={(e) =>
                              setPaymentOption(e.detail.value)
                            }
                            interface="action-sheet"
                          >
                            <IonSelectOption value="tab_account">
                              Member Tab Account
                            </IonSelectOption>

                            <IonSelectOption value="wallet_sms">
                              Wallet Using SMS
                            </IonSelectOption>
                            <IonSelectOption value="wallet_qrcode">
                              Wallet Using MEMBER-APP-TOKEN
                            </IonSelectOption>
                            <IonSelectOption value="card">Card</IonSelectOption>
                            {/* <IonSelectOption value="mobile">Mobile Payment</IonSelectOption> */}
                            <IonSelectOption value="transfer">
                              Bank Transfer
                            </IonSelectOption>
                          </IonSelect>
                        </IonItem>

                        {(paymentOption === "card" ||
                          paymentOption == "wallet_sms" ||
                          paymentOption == "transfer") && (
                          <Box sx={{ mt: 2 }}>
                            {/* <Box>
                          

                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleOTP()}
                              disabled={!showOrderDetails.member_id}
                            >
                              Resend OTP
                            </Button>
                          </Box> */}

                            <Box>
                              {paymentOption == "wallet_sms" && (
                                <>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleOTP()}
                                    disabled={!showOrderDetails.member_id}
                                  >
                                    Send OTP
                                  </Button>

                                  <TextField
                                    label="OTP"
                                    value={`CAAS-${otp}`}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => {
                                      const input = e.target.value;
                                      // Remove the CAAS- part if it's manually typed again
                                      const newValue = input.replace(
                                        /^CAAS-/,
                                        ""
                                      );
                                      setOtp(newValue);
                                    }}
                                    disabled={!showOrderDetails.member_id}
                                  />
                                </>
                              )}
                            </Box>
                          </Box>
                        )}
                      </IonList>
                    )}

                    {paymentOption == "wallet_qrcode" && (
                      <Box sx={{ mt: 2 }}>
                       {/*  <Button
                          variant="contained"
                          color="primary"
                          onClick={startScan}
                          disabled={!showOrderDetails.member_id}
                        >
                          Scan QR Code
                        </Button> */}

                        <TextField
                                    label="MEMBER-APP-OTP"
                                    value={otp}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => {
                                      const input = e.target.value;
                                      // Remove the CAAS- part if it's manually typed again
                                   /*    const newValue = input.replace(
                                        /^CAAS-/,
                                        ""
                                      ); */
                                      setOtp(input);
                                      handleVerify(input)
                                    }}
                                    disabled={!showOrderDetails.member_id }
                                  />
  <Typography variant="body2" color={result.includes('Correct') ? 'success.main' : 'error.main'}>
    {result}
  </Typography>
                      </Box>
                    )}

                    {/* Action Buttons */}
                    <div className="action-buttons">
                      {/* <IonButton
                    expand="block"
                    fill="outline"
                    onClick={() => editOrderHandler(showOrderDetails)}
                    className="close-button"
                  >
                    Edit Order
                  </IonButton> */}

                      {paymentOption &&
                        showOrderDetails?.order_status === "COMPLETED" && (
                          <IonButton
                            expand="block"
                            color="success"
                            onClick={() => handleProcessPayment()}
                            className="process-button"
                            disabled={lockPay} 
                          >
                            <IonIcon slot="start" icon={card} />
                            Process Payment
                          </IonButton>
                        )}

                      <IonButton
                        expand="block"
                        fill="outline"
                        onClick={() => setShowOrderDetails(null)}
                        className="close-button"
                      >
                        Close
                      </IonButton>
                    </div>

                    {/*hide lola end  */}
                  </IonList>
                )}
            </IonCardContent>
          </IonCard>
        )}

        {/* FAB for new order */}
        {/* <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab> */}

  {/*      <div style={{ padding: 20 }}>
      <h2>6-Digit Token Generator</h2>
      <input
        type="text"
        value={token}
        onChange={(e) => setToken(e.target.value)}
        placeholder="Enter Token ID"
      />
     
      
      <div style={{ margin: '10px 0' }}>
        <button onClick={handleVerify}>Verify Token</button>
      </div>
      <div><strong>Result:</strong> {result}</div>
    </div> */}
      </IonContent>

     
 
    </IonPage>
  );
};

export default StewardDashboard;
